import { render, staticRenderFns } from "./PcColComponent.vue?vue&type=template&id=2bc58608&"
import script from "./PcColComponent.vue?vue&type=script&lang=js&"
export * from "./PcColComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports